import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useLanguage } from '../../context/LanguageContext';

const PrivacyPolicyDialog = ({ open, onClose, isDarkMode }) => {
  const { language, t } = useLanguage();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: isDarkMode ? '#1e1e1e' : '#fff',
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
        {language === 'ge' ? 'კონფიდენციალურობის პოლიტიკა' : language === 'ru' ? 'Политика конфиденциальности' : 'Privacy Policy'}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {language === 'ge' ? 'ეფექტური თარიღი: 09.07.2024' : language === 'ru' ? 'Дата вступления: 09.07.2024' : 'Effective Date: 09.07.2024'}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          {/* Georgian Content */}
          {language === 'ge' && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>1. ვინ ვართ ჩვენ</Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM-ისთვის თქვენი კონფიდენციალურობა მნიშვნელოვანია. ეს პოლიტიკა განმარტავს, თუ რა პერსონალურ მონაცემებს ვაგროვებთ საკონტაქტო ფორმების საშუალებით, როგორც იყენებთ მათ და თქვენს უფლებებს მონაცემთა დაცვის ზოგადი რეგულაციის (GDPR) (EU) 2016/679 შესაბამისად.
              </Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM არის ტექნოლოგიური სერვისების მომწოდებელი, რომელიც სპეციალიზირებულია IT მხარდაჭერაზე, პროგრამულ უზრუნველყოფაზე, მობილური აპლიკაციების შემუშავებაზე, ქსელის უსაფრთხოებასა და Web3 გადაწყვეტილებებზე.
              </Typography>
              <Typography variant="body2" paragraph>
                კითხვების შემთხვევაში, გთხოვთ დაგვიკავშირდეთ:
                <br/>• ელ-ფოსტა: info@itforsec.com
                <br/>• ვებ-გვერდი: https://itforsec.com
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>2. რა მონაცემებს ვაგროვებთ</Typography>
              <Typography variant="body2" paragraph>
                ჩვენ ვაგროვებთ მხოლოდ იმ მონაცემებს, რომლებსაც თქვენ ნებაყოფლობით გვაწვდით საკონტაქტო ფორმების საშუალებით. ეს შეიძლება მოიცავდეს:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>სახელი</li>
                <li>ელ-ფოსტა</li>
                <li>ტელეფონის ნომერი (თუ მითითებულია)</li>
                <li>თქვენი შეტყობინების დეტალები</li>
              </Typography>
              <Typography variant="body2" paragraph>
                ჩვენ არ ვიყენებთ ქუქი-ფაილებს (cookies), ანალიტიკურ ინსტრუმენტებს ან მესამე მხარის თრექინგის ტექნოლოგიებს.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>3. დამუშავების მიზანი და სამართლებრივი საფუძველი</Typography>
              <Typography variant="body2" paragraph>
                თქვენს მონაცემებს ვამუშავებთ შემდეგი მიზნებისთვის:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>თქვენს შეკითხვებზე ან მოთხოვნებზე პასუხის გასაცემად</li>
                <li>ჩვენი სერვისებისშესახებ ინფორმაციის მოსაწოდებლად</li>
                <li>ბიზნეს შესაძლებლობებისშესახებ კომუნიკაციისთვის</li>
              </Typography>
              <Typography variant="body2" paragraph>
                <strong>სამართლებრივი საფუძველი:</strong> დამუშავება ეფუძნება თქვენს თანხმობას (ფორმის გამოგზავნისას) და ჩვენს ლეგიტიმურ ინტერესს თქვენს მოთხოვნაზე პასუხის გასაცემად.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>4. მონაცემთა გაზიარება</Typography>
              <Typography variant="body2" paragraph>
                ჩვენ არ ვყიდით და არ ვაზიარებთ თქვენს მონაცემებს მესამე მხარეებთან მარკეტინგული მიზნებისთვის. მონაცემები შეიძლება გაზიარდეს მხოლოდ იმ შემთხვევაში, თუ ეს აუცილებელია თქვენი მოთხოვნის შესასრულებლად ან კანონით გათვალისწინებულ შემთხვევებში.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>5. მონაცემთა შენახვა</Typography>
              <Typography variant="body2" paragraph>
                ჩვენ ვინახავთ მონაცემებს მხოლოდ მანამ, სანამ ეს აუცილებელია თქვენს შეკითხვაზე პასუხისთვის ან ბიზნეს ურთიერთობისთვის. თუ ურთიერთობა არ დამყარდა, მონაცემები წაიშლება გონივრულ ვადაში.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>6. თქვენი უფლებები GDPR-ის მიხედვით</Typography>
              <Typography variant="body2" paragraph>თქვენ გაქვთ უფლება:</Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>მოითხოვეთ წვდომა თქვენს მონაცემებზე</li>
                <li>მოითხოვეთ მონაცემების გასწორება ან წაშლა</li>
                <li>გამოითხოვეთ თანხმობა ნებისმიერ დროს</li>
                <li>შეზღუდოთ მონაცემთა დამუშავება</li>
              </Typography>
              <Typography variant="body2" paragraph>
                უფლებების გამოსაყენებლად დაგვიკავშირდით: info@itforsec.com.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>7. მონაცემთა უსაფრთხოება</Typography>
              <Typography variant="body2" paragraph>
                ჩვენ ვიყენებთ შესაბამის უსაფრთხოების ზომებს თქვენი მონაცემების არასანქცირებული წვდომისგან, შეცვლისგან ან დაკარგვისგან დასაცავად. წვდომა შეზღუდულია მხოლოდ უფლებამოსილ პერსონალზე.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>8. ბავშვების კონფიდენციალურობა</Typography>
              <Typography variant="body2" paragraph>
                ჩვენი სერვისები არ არის განკუთვნილი 16 წლამდე ასაკის პირებისთვის. ჩვენ შეგნებულად არ ვაგროვებთ ბავშვების მონაცემებს.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>9. ცვლილებები პოლიტიკაში</Typography>
              <Typography variant="body2" paragraph>
                პოლიტიკა შეიძლება პერიოდულად განახლდეს. ნებისმიერი ცვლილება გამოქვეყნდება ამ გვერდზე განახლებული თარიღით.
              </Typography>

              <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>დაგვიკავშირდით</Typography>
                <Typography variant="body2">
                  თუ გაქვთ კითხვები მონაცემთა დაცვის შესახებ, მოგვწერეთ: <strong>info@itforsec.com</strong>
                </Typography>
              </Box>
            </>
          )}

          {/* Russian Content */}
          {language === 'ru' && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>1. Кто мы такие</Typography>
              <Typography variant="body2" paragraph>
                Для ITFORSEC.COM ваша конфиденциальность очень важна. Эта Политика конфиденциальности описывает, какие личные данные мы собираем через наши контактные формы, как мы их используем и ваши права в соответствии с Общим регламентом защиты данных (GDPR) (EU) 2016/679.
              </Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM — это поставщик технологических услуг, специализирующийся на IT-поддержке, разработке ПО, мобильных приложениях, сетевой безопасности и Web3-решениях.
              </Typography>
              <Typography variant="body2" paragraph>
                По любым вопросам, касающимся этой политики, пожалуйста, свяжитесь с нами:
                <br/>• Email: info@itforsec.com
                <br/>• Website: https://itforsec.com
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>2. Какие данные мы собираем</Typography>
              <Typography variant="body2" paragraph>
                Мы собираем только те личные данные, которые вы добровольно предоставляете через наши контактные формы. Это может включать:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Имя</li>
                <li>Адрес электронной почты</li>
                <li>Номер телефона (если указан)</li>
                <li>Любые детали сообщения или запроса</li>
              </Typography>
              <Typography variant="body2" paragraph>
                Мы не собираем и не используем файлы cookie, аналитические инструменты или технологии отслеживания сторонних производителей.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>3. Цель и правовые основания обработки</Typography>
              <Typography variant="body2" paragraph>
                Мы обрабатываем ваши данные для:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Ответа на ваши запросы или обращения</li>
                <li>Предоставления информации о наших услугах</li>
                <li>Общения с вами по вопросам поддержки или бизнес-возможностей</li>
              </Typography>
              <Typography variant="body2" paragraph>
                <strong>Правовое основание:</strong> Обработка основана на вашем согласии (при отправке контактной формы) и наших законных интересах в ответе на ваш запрос.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>4. Передача данных</Typography>
              <Typography variant="body2" paragraph>
                Мы не продаем, не сдаем в аренду и не передаем ваши личные данные третьим лицам в маркетинговых целях.
                Мы можем передавать ваши данные доверенным поставщикам услуг только при необходимости обработки вашего запроса или соблюдения законодательных обязательств.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>5. Хранение данных</Typography>
              <Typography variant="body2" paragraph>
                Мы храним ваши данные только так долго, как это необходимо для ответа на ваш запрос или поддержания деловых отношений. Если постоянные отношения не установлены, ваши данные будут удалены после разумного периода.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>6. Ваши права согласно GDPR</Typography>
              <Typography variant="body2" paragraph>
                Вы имеете право:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Запрашивать доступ к личным данным, которые мы храним о вас</li>
                <li>Запрашивать исправление или удаление ваших данных</li>
                <li>Отзывать свое согласие в любое время</li>
                <li>Возражать против обработки ваших данных или ограничивать ее</li>
                <li>Запрашивать переносимость данных</li>
              </Typography>
              <Typography variant="body2" paragraph>
                Чтобы воспользоваться своими правами, свяжитесь с нами: info@itforsec.com.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>7. Безопасность данных</Typography>
              <Typography variant="body2" paragraph>
                Мы принимаем соответствующие меры безопасности для защиты ваших данных от несанкционированного доступа, изменения или потери. Доступ к отправленным формам ограничен только уполномоченным персоналом.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>8. Конфиденциальность детей</Typography>
              <Typography variant="body2" paragraph>
                Наши услуги не предназначены для лиц моложе 16 лет. Мы не собираем данные детей осознанно.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>9. Изменения в Политике</Typography>
              <Typography variant="body2" paragraph>
                Мы можем периодически обновлять эту политику. Любые изменения будут опубликованы на этой странице с указанием пересмотренной даты вступления в силу.
              </Typography>

              <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Свяжитесь с нами</Typography>
                <Typography variant="body2">
                  Если у вас есть вопросы или опасения по поводу ваших личных данных или этой политики, пожалуйста, обращайтесь: <strong>info@itforsec.com</strong>
                </Typography>
              </Box>
            </>
          )}

          {/* English Content (Default) */}
          {language === 'en' && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>1. Who We Are</Typography>
              <Typography variant="body2" paragraph>
                At ITFORSEC.COM, your privacy is important to us. This Privacy Policy outlines what personal data we collect through our contact forms, how we use it, and your rights under the General Data Protection Regulation (GDPR) (EU) 2016/679.
              </Typography>
              <Typography variant="body2" paragraph>
                ITFORSEC.COM is a technology service provider specializing in IT support, software development, mobile application development, network security, and Web3 solutions.
              </Typography>
              <Typography variant="body2" paragraph>
                For any questions regarding this policy, please contact us at:
                <br/>• Email: info@itforsec.com
                <br/>• Website: https://itforsec.com
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>2. What Data We Collect</Typography>
              <Typography variant="body2" paragraph>
                We only collect personal data that you voluntarily provide through our contact forms. This may include:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number (if provided)</li>
                <li>Any message or inquiry details you include</li>
              </Typography>
              <Typography variant="body2" paragraph>
                We do not collect or use cookies, analytics tools, or third-party tracking technologies.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>3. Purpose and Legal Basis for Processing</Typography>
              <Typography variant="body2" paragraph>
                We process your data to:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Respond to inquiries or requests you make</li>
                <li>Provide you with information about our services</li>
                <li>Communicate with you regarding support or business opportunities</li>
              </Typography>
              <Typography variant="body2" paragraph>
                <strong>Legal basis:</strong> This processing is based on your consent (when you submit the contact form) and our legitimate interest in responding to your request.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>4. Data Sharing</Typography>
              <Typography variant="body2" paragraph>
                We do not sell, rent, or share your personal data with third parties for marketing purposes.
                We may share your data with trusted service providers only if required to process your request or comply with legal obligations.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>5. Data Retention</Typography>
              <Typography variant="body2" paragraph>
                We retain your data only as long as necessary to respond to your inquiry or maintain a business relationship. If no ongoing relationship is established, your data will be deleted after a reasonable period.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>6. Your Rights Under GDPR</Typography>
              <Typography variant="body2" paragraph>
                You have the right to:
              </Typography>
              <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
                <li>Request access to the personal data we hold about you</li>
                <li>Request correction or deletion of your data</li>
                <li>Withdraw your consent at any time</li>
                <li>Object to or restrict processing of your data</li>
                <li>Request data portability</li>
              </Typography>
              <Typography variant="body2" paragraph>
                To exercise your rights, contact us at info@itforsec.com.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>7. Data Security</Typography>
              <Typography variant="body2" paragraph>
                We take appropriate security measures to protect your data from unauthorized access, alteration, or loss. Access to form submissions is limited to authorized personnel only.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>8. Children's Privacy</Typography>
              <Typography variant="body2" paragraph>
                Our services are not intended for individuals under 16 years old. We do not knowingly collect data from children.
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>9. Changes to This Policy</Typography>
              <Typography variant="body2" paragraph>
                We may update this policy occasionally. Any changes will be published on this page with a revised effective date.
              </Typography>

              <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Contact Us</Typography>
                <Typography variant="body2">
                  If you have any questions or concerns about your personal data or this policy, please reach out to: <strong>info@itforsec.com</strong>
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary" sx={{ borderRadius: 2 }}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyDialog;
